import { Flex, Text } from '@chakra-ui/react'
import { FaCog, FaPeopleArrows } from 'react-icons/fa'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../../components/ElementoTooltipCmp'
import { iItemFeedbackResponse } from '../../../../interfaces'
import { CheckIsItemPadrao, GetDescricaoItemFeedback, GetNomeItemFeedback } from '../../../../Utils/Helper'

interface iCardProps {
  item: iItemFeedbackResponse
  onOpenModalParticipantes: () => void
}

export const CardItem: React.FC<iCardProps> = ({ item, onOpenModalParticipantes }) => {
  return (
    <Flex alignItems={'center'} gap={'.5rem'} pos={'relative'} w={'100%'}>
      <Text fontSize={'1.125rem'} fontWeight={'600'} w={'2rem'} textAlign={'end'}>{item.ordem}</Text>
      <Flex h={'3rem'} px={'1rem'} border={'1px solid var(--Azul)'} borderRadius={'.25rem'} boxShadow={'var(--SombraBtns)'} position={'relative'} w={'100%'} alignItems={'center'} gap={'.75rem'} justifyContent={'space-between'}>
        <Flex gap={'.75rem'}>
          <Flex alignItems={'center'} justifyContent={'center'} w={'2rem'}>
            <FaPeopleArrows size={26}/>
          </Flex>
          <Flex flexDir={'column'} gap={'4px'} justifyContent={'center'} w={'100%'} lineHeight={'14px'}>
            <Text fontSize={'14px'} fontWeight={700}>{GetNomeItemFeedback(item.tipo)}</Text>
            <Text fontSize={'13px'} fontWeight={400}>{GetDescricaoItemFeedback(item.tipo)}</Text>
          </Flex>
        </Flex>
        <ElementoTooltipCmp bg={'var(--Red)'} label={CheckIsItemPadrao(item.tipo) ? 'Itens que vêm como padrão, não podem ser ocultados para nenhum dos participantes do feedback' : ''}>
          <ButtonCmp leftIcon={<FaCog/>} isDisabled={CheckIsItemPadrao(item.tipo)} VarColor='Roxo' w={'11.5rem'} onClick={onOpenModalParticipantes}>Editar participantes</ButtonCmp>
        </ElementoTooltipCmp>
      </Flex>
    </Flex>
  )
}
